import React, { Fragment } from "react";
import { oneOfType, string, number, func, bool } from "prop-types";

import { SelectListGroup } from "../../../../common/index";

import {
  dayOptions,
  monthOptions,
  yearOptions,
} from "../../../../helpers/index";

export const birthKeys = ["birthDay", "birthMonth", "birthYear"];

const DOB = ({
  dayOfBirth,
  monthOfBirth,
  yearOfBirth,
  handleChange,
  isInvalid,
  oneRowOnMobile = false,
  classes = "",
}) => (
  <Fragment>
    <div className="col-md-12">
      <p className="mb-hf">Date of birth*</p>
    </div>
    <div
      className={`${oneRowOnMobile ? "col-3 col-sm-3" : "col-md-3"}`}
      style={{ marginRight: oneRowOnMobile ? 12 : 0 }}
    >
      <div className={classes}>
        <SelectListGroup
          id="dayOfBirth"
          value={dayOfBirth}
          onChange={(e) => {
            handleChange("birthDay", e.target.value);
          }}
          options={dayOptions}
          classes="register_field "
          isError={isInvalid}
        />
      </div>
    </div>
    <div
      className={`${oneRowOnMobile ? "col-4 col-sm-4" : "col-md-4"}`}
      style={{ marginRight: oneRowOnMobile ? 12 : 0 }}
    >
      <div className={classes}>
        <SelectListGroup
          id="monthOfBirth"
          value={monthOfBirth}
          onChange={(e) => {
            handleChange("birthMonth", e.target.value);
          }}
          options={monthOptions}
          classes="register_field "
          isError={isInvalid}
        />
      </div>
    </div>
    <div className={`${oneRowOnMobile ? "col-3 col-sm-3" : "col-md-3"}`}>
      <div className={classes}>
        <SelectListGroup
          id="yearOfBirth"
          value={yearOfBirth}
          onChange={(e) => {
            handleChange("birthYear", e.target.value);
          }}
          options={yearOptions}
          classes="register_field "
          isError={isInvalid}
        />
      </div>
    </div>
  </Fragment>
);

DOB.propTypes = {
  dayOfBirth: oneOfType([string, number]).isRequired,
  monthOfBirth: oneOfType([string, number]).isRequired,
  yearOfBirth: oneOfType([string, number]).isRequired,
  handleChange: func.isRequired,
  errorMessage: string,
  isInvalid: bool,
  oneRowOnMobile: bool,
  classes: string,
};

export default DOB;
